import React from 'react';
import { Switch } from 'antd';
import { SwitchProps } from 'antd/lib/switch';

export interface IFormSwitch {
    label: string;
    value: boolean;
    onChange: Function;
	disabled?: boolean;
	unCheckedLabel?: string;
	checkedLabel?: string;
    switchFormProps?: SwitchProps;
}
const FormSwitch = ({ label, value, onChange, disabled, unCheckedLabel, checkedLabel, switchFormProps } : IFormSwitch) => {
	return (
		<>
			<div style={{ gridColumn: '1/2' }}>
				<strong>{label}:</strong>
			</div>
			<div style={{ gridColumn: '2/6' }}>
				<Switch checked={!!value} 
					onChange={(checked: boolean) => onChange(checked)} disabled={disabled} unCheckedChildren={unCheckedLabel} checkedChildren={checkedLabel} {...switchFormProps} />
			</div>
		</>
	);
}

export default FormSwitch;
